<template>
  <div>
    <div @click="launchFile()">
      <slot name="activator"></slot>
    </div>

    <input type="file"
       ref="file"
       :name="filename"
       accept=".jpg, .jpeg, .png"
       v-on:change="changeImage($event.target.files)"
       style="display:none">
       
    <v-dialog 
      v-model="dialog"
      width="500">
      <v-card
        class="pa-0 ma-0"
        flat>
        <v-card
          color="red accent-2">
          <v-list-item>
            <v-list-item-avatar color="red accent-2" size="30">
              <v-icon color="white" large>mdi-alert</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-card-text class="caption white--text pa-0">
                {{ message.error }}
              </v-card-text>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'image-input',
    data: () => ({
      dialog: false,
      filename: 'file',
      process: {
        load: false
      },
      message: {
        error: ''
      }
    }),
    methods: {
      launchFile () {
        this.$refs.file.click()
      },
      async changeImage (file) {
        let image = file[0]
        if (file.length > 0) {
          if (image.type != 'image/jpg' && image.type != 'image/jpeg' && image.type != 'image/png') {
            this.dialog = true
            this.message.error = 'Silahkan pilih gambar dengan format .jpg / .jpeg / .png'
          } else if (image.size > 10485760) {
            this.dialog = true
            this.message.error = 'Maksimal gambar 10MB'
          } else {
            let formData = new FormData()
            formData.append('key', 'image')
            formData.append('image', image)

            this.process.load = true
            
            this.$emit('input', {
              process : this.process.load
            })

            fetch(`${process.env.VUE_APP_API_URL}general/upload_image`, {
              method: 'POST',
              body: formData,
              headers: {
                Authorization: `${process.env.VUE_APP_XAUTH}`
              } 
            })
            .then(res => res.json())
            .then(response => {
              if (response.status === 200) {
                this.process.load = false

                this.$emit('input', {
                  filename: response.results.data.filename,
                  filepath: response.results.data.filepath,
                  fileuri: response.results.data.fileuri,
                  process : this.process.load
                })
              } else {
                this.process.load = false
                
                this.$emit('input', {
                  process : this.process.load
                })

                this.dialog = true
                this.message.error  = response.message
              }
            })
          }
        }
      }
    }
  }
</script>